module.exports = "<span>{{ orgUserDisplay }}</span>"